import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {string} State */

/** @type {State} */
const initialState = '';

/**
 * @param {State} state
 * @param {import('modules/notifications/types').FetchNotificationsConfigurationActionSuccess|import('modules/notifications/types').PatchNotificationsConfigurationActionSuccess} payload
 * @returns {State} The updated state
 */
const set = (_, { payload }) => payload.message ?? payload;

/** @returns {State} An empty state (`''`) */
const clear = () => '';

export default createReducer(initialState, {
  [types.FETCH_CONFIGURATION]: clear,
  [types.PATCH_CONFIGURATION]: clear,
  [types.FETCH_CONFIGURATION_FAILURE]: set,
  [types.PATCH_CONFIGURATION_FAILURE]: set,
});
